export const container = `flex items-center gap-1 text-xs text-gray-400 mb-2`;
